import { jsx as _jsx } from "react/jsx-runtime";
import ExpandIcon from '@mui/icons-material/KeyboardArrowRight';
import { css } from '@mui/material';
export const accordionComponentOverrides = {
    MuiAccordion: {
        styleOverrides: {
            root: ({ theme }) => css `
                --accordion-border: 1px solid ${theme.tokens.FuelColorBorderBase};

                /* DEFAULTS */
                border: unset;
                box-shadow: unset;
                box-sizing: border-box;
                background-color: ${theme.tokens.FuelColorWhite};
                margin-block: 0rem;

                &:before, &:after {
                    display: none;
                }

                &:not(:first-of-type) {
                    border-top: var(--accordion-border)
                }

                &:first-of-type {
                    border-top-left-radius: ${theme.tokens.FuelBorderRadiusLg};
                    border-top-right-radius: ${theme.tokens.FuelBorderRadiusLg};
                }

                &:last-of-type {
                    border-bottom-right-radius: ${theme.tokens.FuelBorderRadiusLg};
                    border-bottom-left-radius: ${theme.tokens.FuelBorderRadiusLg};
                }

                &.Mui-expanded {
                    margin-block: unset;
                }

                &.Mui-disabled {
                    background-color: ${theme.tokens.FuelColorWhite};
                    opacity: 0.4;
                }

                /* ACCORDION VARIANTS */
                &.MuiPaper-elevated {
                    box-shadow: unset; // NOTE: controlled by AccordionContainer
                }

                &.MuiPaper-outlined:not(:first-of-type) {
                    border-top: var(--accordion-border)
                }

                &[data-fuel-right-aligned=true] {
                    .MuiAccordionSummary-root {
                        padding-block: ${theme.tokens.FuelSpacing4};
                        padding-inline: ${theme.tokens.FuelSpacing6} 0.75rem;
                    }

                    .MuiAccordionSummary-content, .MuiAccordionSummary-expandIconWrapper {
                        order: 0;
                    }

                    .MuiAccordionSummary-expandIconWrapper {
                        margin-inline: ${theme.tokens.FuelSpacing2} 0rem;
                        transform: rotate(90deg);

                        &.Mui-expanded {
                            transform: rotate(270deg);
                        }
                    }

                    .MuiAccordionDetails-root, .MuiAccordionActions-root {
                        padding-inline: ${theme.tokens.FuelSpacing6} ${theme.tokens.FuelSpacing12};
                    }
                }


                &[data-fuel-spaced=true] {
                    border-top: unset;

                    &.MuiPaper-elevated {
                        box-shadow: ${theme.tokens.FuelShadowBase};
                    }

                    &.MuiPaper-outlined {
                        border-top: unset;
                        outline: var(--accordion-border);
                        box-shadow: unset;
                    }

                    &:not(:last-of-type) {
                        margin-bottom: ${theme.tokens.FuelSpacing2};
                    }

                    border-top-left-radius: ${theme.tokens.FuelBorderRadiusLg};
                    border-top-right-radius: ${theme.tokens.FuelBorderRadiusLg};
                    border-bottom-right-radius: ${theme.tokens.FuelBorderRadiusLg};
                    border-bottom-left-radius: ${theme.tokens.FuelBorderRadiusLg};

                    &:first-of-type, &:last-of-type {
                        border-top-left-radius: ${theme.tokens.FuelBorderRadiusLg};
                        border-top-right-radius: ${theme.tokens.FuelBorderRadiusLg};
                        border-bottom-right-radius: ${theme.tokens.FuelBorderRadiusLg};
                        border-bottom-left-radius: ${theme.tokens.FuelBorderRadiusLg};
                    }
                }

                &[data-fuel-dense=true] {
                    .MuiAccordionSummary-root {
                        padding-block: ${theme.tokens.FuelSpacing3};
                        padding-inline: ${theme.tokens.FuelSpacing1} ${theme.tokens.FuelSpacing3};
                        gap: ${theme.tokens.FuelSpacing1};
                    }

                    .MuiAccordionDetails-root {
                        padding-block: 0rem ${theme.tokens.FuelSpacing6};
                        padding-inline: ${theme.tokens.FuelSpacing10} ${theme.tokens.FuelSpacing3};
                    }

                    &[data-fuel-right-aligned=true] {
                        .MuiAccordionSummary-root {
                            padding-inline: ${theme.tokens.FuelSpacing4} ${theme.tokens.FuelSpacing1};
                        }

                        .MuiAccordionDetails-root, .MuiAccordionActions-root {
                            padding-inline: ${theme.tokens.FuelSpacing4} ${theme.tokens.FuelSpacing10};
                        }
                    }
                }
            `
        }
    },
    MuiAccordionSummary: {
        defaultProps: {
            expandIcon: _jsx(ExpandIcon, {})
        },
        styleOverrides: {
            root: ({ theme }) => css `
                min-height: unset;
                line-height: ${theme.tokens.FuelSpacing6};

                padding-block: ${theme.tokens.FuelSpacing4};
                padding-inline: ${theme.tokens.FuelSpacing2} ${theme.tokens.FuelSpacing4};
                gap: ${theme.tokens.FuelSpacing2};

                border-top-left-radius: ${theme.tokens.FuelBorderRadiusLg};
                border-top-right-radius: ${theme.tokens.FuelBorderRadiusLg};
                border-bottom-left-radius: ${theme.tokens.FuelBorderRadiusLg};
                border-bottom-right-radius: ${theme.tokens.FuelBorderRadiusLg};

                &:focus-visible {
                    background: unset;
                    outline: 2px solid ${theme.tokens.FuelColorFocused};
                    outline-offset: -2px;
                }


                &.Mui-expanded {
                    min-height: unset;
                }

                &.Mui-disabled {
                    opacity:  unset;
                }

                .MuiAccordionSummary-content {
                    order: 2;
                    margin: unset;
                    line-height: ${theme.tokens.FuelSpacing6};
                    color: ${theme.palette.text.primary};

                    &.Mui-expanded {
                        margin: unset;
                    }
                }

                .MuiAccordionSummary-expandIconWrapper {
                    order: 1;
                    height: ${theme.tokens.FuelSpacing6};
                    width: ${theme.tokens.FuelSpacing6};
                    margin-inline: ${theme.tokens.FuelSpacing1};

                    transform: rotate(0deg);

                    &.Mui-expanded {
                        transform: rotate(90deg);
                    }
                }
            `
        }
    },
    MuiAccordionDetails: {
        styleOverrides: {
            root: ({ theme }) => css `
                padding-block: 0rem ${theme.tokens.FuelSpacing8};
                padding-inline: ${theme.tokens.FuelSpacing12} ${theme.tokens.FuelSpacing4};

                &:has(+ .MuiAccordionActions-root) {
                    padding-bottom: ${theme.tokens.FuelSpacing6};
                }
            `
        }
    },
    MuiAccordionActions: {
        styleOverrides: {
            root: ({ theme }) => css `
                padding-block: 0rem ${theme.tokens.FuelSpacing8};
                padding-inline: ${theme.tokens.FuelSpacing12} ${theme.tokens.FuelSpacing4};
            `
        }
    }
};
